import { dataBaseClient } from '@/utils/networking'

export default {
  install (Vue, options) {
    let htmlDecode = function (str) {
      var s = ''
      if (str.length === 0) return ''
      s = str.replace(/&amp;/g, '&')
      s = s.replace(/&lt;/g, '<')
      s = s.replace(/&gt;/g, '>')
      s = s.replace(/&nbsp;/g, ' ')
      s = s.replace(/&#39;/g, '\'')
      s = s.replace(/&quot;/g, '"')
      return s
    }
    Vue.directive('fix-html', {
      bind: function (el, htmlV) {
        console.log(htmlV.value)
        el.innerHTML = htmlDecode(htmlV.value)
        console.log(el.innerHTML)
      }
    })

    // 获取联赛基本信息
    Vue.prototype.$ft_getLeagueInfo = function (leagueId, ballType) {
      return dataBaseClient.doGet('database/leagueInfo', {
        'leagueId': leagueId,
        'ballType': ballType
      })
    }

    // 足球获取年份列表
    Vue.prototype.$ft_getYearList = function (leagueId) {
      return dataBaseClient.doGet('f_league/yearList', {
        'leagueId': leagueId
      })
    }

    // 足球联赛获取联赛赛程比赛列表
    Vue.prototype.$ft_getLeagueFixture = function (leagueId) {
      return dataBaseClient.doGet('f_league/leagueFixture', {
        'leagueId': leagueId
      })
    }
    // 足球联赛获取联赛赛程比赛列表（往年）
    Vue.prototype.$ft_getFixtureByYear = function (leagueId, year, type) {
      return dataBaseClient.doGet('f_league/fixtureByYear', {
        'leagueId': leagueId,
        'year': year,
        'type': type
      })
    }

    // 足球联赛积分
    Vue.prototype.$ft_getLeagueStanding = function (leagueId) {
      return dataBaseClient.doGet('f_league/leagueStanding', {
        'leagueId': leagueId
      })
    }
    // 足球联赛积分 (往年)
    Vue.prototype.$ft_getStandingByYear = function (leagueId, year) {
      return dataBaseClient.doGet('f_league/standingByYear', {
        'leagueId': leagueId,
        'year': year
      })
    }

    // 足球联赛射手榜
    Vue.prototype.$ft_getLeagueShooter = function (leagueId) {
      return dataBaseClient.doGet('f_league/leagueShooter', {
        'leagueId': leagueId
      })
    }
    // 足球联赛射手榜(往年)
    Vue.prototype.$ft_getShooterByYear = function (leagueId, year) {
      return dataBaseClient.doGet('f_league/shooterByYear', {
        'leagueId': leagueId,
        'year': year
      })
    }

    // 盘路统计
    Vue.prototype.$ft_getHistoryOdds = function (leagueId) {
      return dataBaseClient.doGet('f_league/historyOdds', {
        'leagueId': leagueId
      })
    }
    // 盘路统计 年份（eg.联赛的年份为2019-2020，杯赛的为2020）类别（1=联赛，2=杯赛）
    Vue.prototype.$ft_getOddsByYear = function (leagueId, year) {
      return dataBaseClient.doGet('f_league/oddsByYear', {
        'leagueId': leagueId,
        'year': year
      })
    }

    // 球队信息
    Vue.prototype.$ft_getTeamInfo = function (teamId) {
      return dataBaseClient.doGet('f_team/teamInfo', {
        'teamId': teamId
      })
    }

    // 球队赛程
    Vue.prototype.$ft_getTeamFixture = function (teamId) {
      return dataBaseClient.doGet('f_team/teamFixture', {
        'teamId': teamId
      })
    }

    // 球队数据统计
    Vue.prototype.$ft_getTeamStatistics = function (teamId) {
      return dataBaseClient.doGet('f_team/teamStatistics', {
        'teamId': teamId
      })
    }

    // 球队往绩
    Vue.prototype.$ft_getTeamHistory = function (teamId) {
      return dataBaseClient.doGet('f_team/teamHistory', {
        'teamId': teamId
      })
    }

    // 球队阵容
    Vue.prototype.$ft_getTeamPlayerList = function (teamId) {
      return dataBaseClient.doGet('f_team/teamPlayerList', {
        'teamId': teamId
      })
    }

    Vue.prototype.$dataBaseClient = dataBaseClient.instance
  }
}
